// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + chunkId + "." + {25: "9e1849236d275f88f2c2",310: "e84d6c92df68ea626dc1",}[chunkId] + ".js"
}